import { Compass } from '@phosphor-icons/react'
import * as React from 'react'
import cn from 'classnames'
import { trackEvent } from '../../services/event-tracker'
import { observer } from 'mobx-react-lite'
import { GetStartedVm } from './get-started-vm'

type GetStartedModalButtonProps = {
  className?: string
  onOpenChange?(open: boolean): void
}

export const GetStartedModalButton = observer(
  (props: GetStartedModalButtonProps) => {
    const { className, onOpenChange } = props

    const vm = new GetStartedVm()

    if (!vm.showGetStarted) return null

    const openGetStartedModal = () => {
      onOpenChange?.(true)
      trackEvent('$track_get_started_modal_button_clicked')
    }

    return (
      <button
        type="button"
        onClick={openGetStartedModal}
        className={cn(
          'flex flex-row items-center gap-x-2 rounded w-full min-h-[2.5rem] h-10 px-3 font-bold bg-green-light hover:brightness-95 text-progression-green transition-colors',
          className,
        )}
      >
        <Compass weight="bold" size="14" aria-hidden />
        Explore and create
      </button>
    )
  },
)
